import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaGlobe, FaFacebookF, FaInstagram } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import './AskQuestionPage.css'; 

const AskQuestionPage = () => {
  const { t, i18n } = useTranslation();
  const [showLangMenu, setShowLangMenu] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [title, setTitle] = useState("");
  const [question, setQuestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); 

  // Ambient mouse glow tracker
  useEffect(() => {
    const handleMouseMove = (e) => {
      const container = document.querySelector('.buildpage-form-container');
      if (container) {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        container.style.setProperty('--glow-x', `${x}%`);
        container.style.setProperty('--glow-y', `${y}%`);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = lang === "ar" ? "rtl" : "ltr";
    setShowLangMenu(false);
  };

  const submit = async () => {
    if (!name || !email || !title || !question) {
      alert(t("Please fill all required fields."));
      return;
    }

    setLoading(true);
    setSuccessMessage("");

    try {
      const url = "https://xrxkmksbutmuouddtzcm.supabase.co/functions/v1/Askquestion";
      await axios.post(url, { name, email, phone, title, question });

      setSuccessMessage(t("Your question has been sent successfully!"));
      setName(""); setEmail(""); setPhone(""); setTitle(""); setQuestion("");
    } catch (error) {
      console.error(error);
      alert(error.message);
    }

    setLoading(false);
  };

  return (
    <div className="buildpage-form-container">
      {/* Ambient background glow */}
      <div className="ambient-glow"></div>

      {/* Language Switcher Top Bar */}
      <div className="about-topbar">
        <div className="lang-switcher">
          <button 
            className="lang-toggle" 
            onClick={() => setShowLangMenu(!showLangMenu)}
            aria-label={t("Toggle language menu")}
          >
            <FaGlobe size={18} />
            <span>{i18n.language.toUpperCase()}</span>
          </button>
          {showLangMenu && (
            <div className="language-dropdown">
              <div onClick={() => changeLanguage("en")}>{t("English")}</div>
              <div onClick={() => changeLanguage("ar")}>{t("Arabic")}</div>
            </div>
          )}
        </div>
      </div>

      <form
        className="buildpage-form reveal"
        style={{ "--delay": "0.2s" }}
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <h2>{t("Ask a Question")}</h2>

        {successMessage && <p style={{ color: "var(--signal)", marginBottom: "15px" }}>{successMessage}</p>}

        {/* Honeypot field */}
        <input
          type="text"
          name="phone_hidden"
          style={{ display: "none" }}
          autoComplete="off"
          value={""}
          onChange={() => {}}
        />

        <label>{t("Name")} *</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />

        <label>{t("Email")} *</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

        <label>{t("Phone (Optional)")}</label>
        <input type="text" value={phone} onChange={(e) => setPhone(e.target.value)} />

        <label>{t("Title")} *</label>
        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />

        <label>{t("Your Question")} *</label>
        <textarea value={question} onChange={(e) => setQuestion(e.target.value)} rows={4} />

        <div className="button-group">
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? t("Submitting...") : t("Submit")}
          </button>
        </div>
      </form>

      {/* Bottom Social Media Row */}
      <div className="bottom-social-row reveal" style={{ "--delay": "0.4s" }}>
        <a
          href="https://www.facebook.com/EmkaCode.tech"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FaFacebookF />
        </a>
        <a
          href="https://www.instagram.com/emkacode/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram />
        </a>
      </div>
    </div>
  );
};

export default AskQuestionPage;